import { render, staticRenderFns } from "./GerarEtiquetaAP.vue?vue&type=template&id=65b1f5ae&"
import script from "./GerarEtiquetaAP.vue?vue&type=script&lang=js&"
export * from "./GerarEtiquetaAP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports